<!-- 学员评价 -->
<template>
  <div class="appraiseBox" @scroll="handleScroll" ref="scroll">
    <div class="student-evaluation" ref="content">
      <div
        class="content-box"
        v-for="(item, index) in evaluateData"
        :key="index"
        :class="columNum === 3? 'columNum3' : ''"
      >
        <img
          v-for="(item1, index1) in item.imgUrlList"
          :key="index1"
          :src="item1.img"
          alt=""
          :style="
            cur == item1.id ? styleData.imgHoverBorder : styleData.imgBorder
          "
          @mouseenter="changeCur(item1.id)"
          @mouseout="changeCur(0)"
          @click="provideIndex(index, index1)"
        />
      </div>
    </div>
    <div
      class="scorll-box"
      :style="{
        '--scrollColor': scrollColor,
      }"
    >
      <div
        class="scorll-block"
        :style="{
          '--blockColor': blockColor,
          '--box-left': this.scroll + 'px',
        }"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    step: {
      value: {
        type: Number,
        default() {
          return 0;
        },
      },
    },
    columNum: {
      value: {
        type: Number,
        default() {
          return 4;
        },
      },
    },
    scrollColor: {
      value: {
        type: String,
        default() {
          return "rgba(75, 132, 250, 0.16)";
        },
      },
    },
    blockColor: {
      value: {
        type: String,
        default() {
          return "#4b84fa";
        },
      },
    },
    evaluateData: {
      value: {
        type: Array,
        default() {
          return [];
        },
      },
    },

    styleData: {
      value: {
        type: Object,
        default() {
          return {};
        },
      },
    },
  },
  mounted() {
    const contentClientWidth = this.$refs.content.clientWidth;
    const contentScrollWidth = this.$refs.content.scrollWidth;
    this.scroll = contentScrollWidth - contentClientWidth;
    this.$refs.scroll.scrollLeft = this.scroll / 2;
    let left = (contentScrollWidth - contentClientWidth) / 17 / 2;
    if (left >= 1) {
      this.scroll = left;
    } else {
      this.scroll = 0;
    }
  },
  computed: {
    styleVar() {
      return {
        "--box-left": this.scroll + "px",
      };
    },
  },
  data() {
    return {
      cur: 0,
      scroll: 0,
    };
  },
  methods: {
    provideIndex(index, index1) {
      this.$emit("provideIndex", index, index1);
    },

    handleScroll() {
      let dom = this.$refs.content.getBoundingClientRect();

      let left = Math.abs(parseInt(dom.x)) / (this.step || 17);

      if (left >= 1) {
        this.scroll = left;
      } else {
        this.scroll = 0;
      }
    },
    changeCur(index) {
      this.cur = index;
    },
  },
};
</script>

<style lang="scss" scoped>
.appraiseBox::-webkit-scrollbar {
  display: none;
  width: 0 !important;
  height: 0 !important;
  color: transparent;
}
.appraiseBox::-webkit-scrollbar {
  display: none;
  width: 0 !important;
  height: 0 !important;
  color: transparent;
}
.appraiseBox {
  overflow-x: auto;
  margin-top: 52px;
  .student-evaluation {
    display: flex;
    align-items: center;
    position: relative;

    &::hover {
      left: 0 !important;
    }
    .content-box {
      position: relative;
      margin: 0px 0 0 32px;
      width: 252px;
      flex-shrink: 0;

      border-radius: 12px;
      &.columNum3 {
        width: 487px;
      }
      img {
        width: 100%;
        height: 50%;
        border-radius: 18px;
        box-shadow: 0px 6px 18px 0px rgba(94, 123, 218, 0.08),
          0px 4px 6px -4px rgba(94, 123, 218, 0.12);
        cursor: default;
        transition: 0.5s ease all;
        box-sizing: border-box;

        &:nth-child(odd) {
          margin-bottom: 22px;
        }
      }
    }

    .content-box:last-child {
      padding-right: 32px;
    }
  }

  /* .scorll-box {
    position: absolute;
    left: 50%;
    margin-top: 30px;
    transform: translate(-50%, 0px);
    width: 48px;
    height: 6px;
    background: var(--scrollColor);
    border-radius: 3px;
    .scorll-block {
      position: absolute;
      left: var(--box-left);
      width: 24px;
      height: 6px;
      background: var(--blockColor);
      border-radius: 3px;
    }
  } */
}
</style>
